/**
 *
 * Asynchronously loads the component for ProfilePlan
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
